import styled from "styled-components";

export const Flex = styled.div`
      display:flex;
      flex:1;
      
`;

export const FlexMinHeightContent = styled(Flex)`
min-height: -webkit-min-content;
`;

export const FlexCenter = styled(Flex)`
    align-items: center;
    justify-content: center;
`;

export const FlexColumn = styled(Flex)`
  flex-direction: column;
`;

export const FlexColumnCenter = styled(FlexCenter)`
flex-direction: column;
`;

export const FlexAutoScroll = styled(Flex)`
 overflow: auto;
`;

export const ScrollableRelativeStyled = styled.div`
    position: relative;
    flex: 1;
`;

export const ScrollableStyled = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    overflow: auto;
    font-family: Arial,Helvetica Neue,Helvetica,sans-serif;
`;
export const ScrollableCenterContentStyled = styled(ScrollableStyled)`
    //align-items: center;
    //justify-content: center;
    display: flex;

`;


// ======



